import React from 'react';
import VideoSlide from '../../body/VideoSlide';
import { Text } from '@mantine/core';

const DescriptiveCommenting = () => {
  return <VideoSlide vidSrc={1194418647}></VideoSlide>;
};

export default DescriptiveCommenting;
